<mat-tab-group mat-stretch-tabs="false" animationDuration="0ms" [selectedIndex]="selectedMainTabIndex()"
  (selectedTabChange)="handlerMainTabClick($event)" class="secondary-tabs"
  *ngIf="!isPageLoading && selectedMainTabData && selectedMainTabData.mainTabs">

  <div *ngFor="let mainTab of selectedMainTabData.mainTabs">
    <mat-tab [label]="mainTab.name">
      <mat-card class="mb-0">
        <mat-card-content>
          <ng-container *ngIf="!isMainTabLoading">
            <h4 class="title">{{ selectedMainTabData.selectedMainTab.title }}</h4>
            <div class="description" [innerHTML]="selectedMainTabData.selectedMainTab.description"></div>
            <a *ngIf="selectedMainTabData.selectedMainTab.linkButtonUrl" mat-stroked-button color="primary"
              [href]="selectedMainTabData.selectedMainTab.linkButtonUrl">{{selectedMainTabData.selectedMainTab.linkButtonText}}</a>
          </ng-container>
          <ng-container *ngIf="isMainTabLoading">
            <ng-container *ngTemplateOutlet="mainTabContentSkeleton"></ng-container>
          </ng-container>
          <mat-tab-group *ngIf="!isMainTabLoading && selectedMainTabData.selectedMainTab.subTabs.length > 0" mat-stretch-tabs="false"
            animationDuration="0ms" [selectedIndex]="selectedSubTabIndex()"
            (selectedTabChange)="handlerSubTabClick($event)">
            <mat-tab *ngFor="let subTab of selectedMainTabData.selectedMainTab.subTabs" [label]="subTab.name">

              <ng-container *ngIf="isSubTabLoading">
                <ng-container *ngTemplateOutlet="subTabContentSkeleton"></ng-container>
              </ng-container>

              <div *ngIf="!isSubTabLoading && selectedSubTabData && selectedSubTabData.blockLists">
                <div *ngFor="let block of selectedSubTabData.blockLists">
                  <div class="department-block-section" [attr.blocklist-id]="block.id" *ngIf="block.html" [innerHTML]="block.html | safeHtml"></div>
                  <div class="department-block-section" [attr.blocklist-id]="block.id" *ngIf="block.angularBlockListType">
                    <div [ngSwitch]="block.angularBlockListType">
                      <ng-container *ngSwitchCase="angularBlockListType.PortalVideoWithDescriptionBlockList">
                        <app-portal-video-with-description
                          [data]="block.angularBlockListData"></app-portal-video-with-description>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalPromotedInfoBlockList">
                        <app-portal-promoted-info [data]="block.angularBlockListData"></app-portal-promoted-info>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalEventsBlockList">
                        <app-portal-event [data]="block.angularBlockListData"></app-portal-event>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalSupportInfoBlockList">
                        <app-portal-support-info [data]="block.angularBlockListData"></app-portal-support-info>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalCareerPromotedContentBlockList">
                        <app-portal-career-promoted-content
                          [data]="block.angularBlockListData"></app-portal-career-promoted-content>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalOrganizationalServicesBlockList">
                        <app-portal-organizational-services
                          [data]="block.angularBlockListData"></app-portal-organizational-services>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalContentFooterBlockList">
                        <app-portal-content-footer [data]="block.angularBlockListData"></app-portal-content-footer>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.EventsBlockBlockList">
                        <app-event-block [data]="block.angularBlockListData"></app-event-block>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.MessageBlockList">
                        <app-message-block [data]="block.angularBlockListData"></app-message-block>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalLinksBlockList">
                        <app-portal-links [data]="block.angularBlockListData"></app-portal-links>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.PortalQuestionAndAnswerBlockList">
                        <app-portal-questions-and-answers
                          [data]="block.angularBlockListData.result"></app-portal-questions-and-answers>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.AdditionalLinksBlockList">
                        <app-additional-links-block-list
                          [data]="block.angularBlockListData"></app-additional-links-block-list>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.SuccessStoriesCubesAngularBlockList">
                        <app-success-stories-cubes [blockData]="block.angularBlockListData"></app-success-stories-cubes>
                      </ng-container>
                      <ng-container *ngSwitchCase="angularBlockListType.CollaborationsAngularBlockList">
                        <app-collaborations [blockData]="block.angularBlockListData"></app-collaborations>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>

            </mat-tab>
          </mat-tab-group>
        
        </mat-card-content>
      </mat-card>
    </mat-tab>
  </div>
</mat-tab-group>

<div *ngIf="isPageLoading" aria-hidden="true" class="skeleton tabs-group">
  <div class="tabs-selector">
    <div class="tab-label"></div>
    <div class="tab-label" *ngFor="let _ of [].constructor(3)">
      <app-skeleton [borderRadius]="0"/>
    </div>
  </div>
  <div class="tab-content">
    <ng-container *ngTemplateOutlet="mainTabContentSkeleton"></ng-container>
  </div>
</div>

<ng-template #mainTabContentSkeleton>
  <app-skeleton class="title" [type]="'text'" [symbolsCount]="20"/>
  <div class="description">
    <app-skeleton [type]="'text'" [symbolsCount]="60"/>
  </div>
  <app-skeleton [height]="50" [width]="100" class="sub-tab-button skeleton"/>

  <div class="sub-tabs skeleton">
    <div class="sub-tabs-selector">
      <div *ngFor="let _ of [].constructor(4)" class="sub-tab-item">
        <app-skeleton [type]="'text'" [symbolsCount]="5"/>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="subTabContentSkeleton"></ng-container>
  </div>
</ng-template>

<ng-template #subTabContentSkeleton>
  <div *ngFor="let _ of [].constructor(2)" class="department-block-section">
    <app-skeleton [height]="300"/>
  </div>
</ng-template>